import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../css/AboutUs.css';
import Section from '../components/Section';
import { Link } from "react-router-dom";
// Define a type for props
interface AboutUsProps {
  isDisplayShort?: boolean; // Optional boolean prop
}

const AboutUs: React.FC<AboutUsProps> = ({ isDisplayShort = false }) => {
  return (
    <div className="about-us">
      <Section subtitle="Who We Are?" title="Few Words About Us" />
      {isDisplayShort && (
        <div className='row'>
 <div className="col-md-12 wow text-center fadeInLeft" >
        <div className="section-content container">
            <p className="text-justify">
          Techmark Universal Company specializes in the engineering, supply, installation, integration, testing, commissioning, and servicing of a wide range of Instrumentation, Gas Metering, Telecom products, Automation, Electrical, Mechanical, and other Industrial products. We provide cutting-edge solutions for measurement, monitoring, and control in highly demanding industries.
          Our valued customers come from diverse sectors, including Oil & Gas, Chemical, Pharmaceutical, Specialty gas, Defence, Automobile, Power & Energy, Metals, Mining, pharmaceuticals & life sciences, water & wastewater, food & beverage, and equipment manufacturing.
           </p>
           <Link to="/aboutus" className="btn btn-primary mt-3 mr-3">Read More</Link>
           <Link to="/contactus" className="btn btn-secondary mt-3 mr-3">Contact Us</Link>
        </div>
        </div>
        </div>
  
      )}
      {!isDisplayShort && (
        <>
          <section className="section-content container">
            <p className="text-justify">
              Techmark Universal Company specializes in the engineering, supply, installation, integration, testing, commissioning, and servicing of a wide range of Instrumentation, Gas Metering, Telecom products, Automation, Electrical, Mechanical, and other Industrial products. We provide cutting-edge solutions for measurement, monitoring, and control in highly demanding industries.
              Our valued customers come from diverse sectors, including Oil & Gas, Chemical, Pharmaceutical, Specialty gas, Defence, Automobile, Power & Energy, Metals, Mining, pharmaceuticals & life sciences, water & wastewater, food & beverage, and equipment manufacturing.
              At Techmark Universal, our team of skilled sales and application engineers brings extensive expertise in industrial automation and applications. We analyze end-user requirements, understand application-specific needs, and recommend the most suitable components based on technical specifications and budget constraints.
              We prioritize customer satisfaction by offering multiple options for every requirement, ensuring cost-effective, innovative, and market-driven solutions.
              We represent many MNC companies in India. We are available on online platforms like GEMS Portal to cater to the government segment and on AMAZON to provide various products.
            </p>
          </section>
          {/* <section className="our-mission">
            <h2>Our Mission</h2>
            <p>
              Our mission is to deliver high-quality, reliable, and cutting-edge technology solutions to businesses worldwide.
              We aim to be a global leader in our field by continuously improving our services and providing value to our clients.
            </p>
          </section>
          <section className="our-values">
            <h2>Our Values</h2>
            <ul>
              <li>Integrity and Honesty</li>
              <li>Customer-Centric Approach</li>
              <li>Excellence in Everything We Do</li>
              <li>Innovation and Creativity</li>
              <li>Sustainability and Social Responsibility</li>
            </ul>
          </section> */}
          <section className="contact-us">
            <h2>Contact Us</h2>
            <p>If you'd like to know more about our company, feel free to reach out to us. We're always happy to talk!</p>
            <Link to="/contactus" className="btn btn-secondary mt-3 mr-3">Contact Us</Link>
          </section>
        </>
      )}
    </div>
  );
};

export default AboutUs;
